
const Module = () => import('./ProgramModule.vue');

import { PROGRAM_ROUTES } from '@/router/routeConstants';

const setBreadcrumbs = (to, from) => {
    let breadcrumbs = [];

    if (from.name == PROGRAM_ROUTES.ORGANIZATIONS.name && to.name == PROGRAM_ROUTES.ORGANIZATION.name) {
        breadcrumbs.push({ label: 'Registered Organizations', route: PROGRAM_ROUTES.ORGANIZATIONS.fullPath });
        breadcrumbs.push({ label: to.meta.title });
    } else if (from.name == PROGRAM_ROUTES.REGISTRATION_APPROVALS.name && to.name == PROGRAM_ROUTES.ORGANIZATION.name) {
        breadcrumbs.push({ label: 'Registration Approvals', route: PROGRAM_ROUTES.REGISTRATION_APPROVALS.fullPath });
        breadcrumbs.push({ label: to.meta.title });
    } else {
        breadcrumbs = to.meta.breadcrumb;
    }

    return breadcrumbs;
};

const filterPath = (to, from, next) => {
    if (to.fullPath !== to.path) {
        to.meta.breadcrumb = setBreadcrumbs(to, from);
        next({ path: to.path });
    } else {
        to.meta.breadcrumb = setBreadcrumbs(to, from);
        next();
    }
};

const moduleRoutes = 
    {
        path: '/program',
        component: Module,
        children: [
            {
                path: PROGRAM_ROUTES.ORGANIZATIONS.path,
                name: PROGRAM_ROUTES.ORGANIZATIONS.name,
                meta: {
                    title: 'Registered Organizations',
                    requiresAuth: true,
                    requiresAdmin: true,
                    instructions: 'Below are a list of organizations that have registered and been approved to participate in the program.',
                    breadcrumb: [
                        { label: 'Registered Organizations' }
                    ]
                },
                component: () => import('./views/OrganizationsView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.REGISTRATION_APPROVALS.path,
                name: PROGRAM_ROUTES.REGISTRATION_APPROVALS.name,
                meta: {
                    title: 'Registration Approvals',
                    requiresAuth: true,
                    requiresAdmin: true,
                    instructions: 'Below are a list of pending registration approvals.',
                    breadcrumb: [
                        { label: 'Registration Approvals'}
                    ]
                },
                component: () => import('./views/RegistrationApprovalsView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.ORGANIZATION.path,
                name: PROGRAM_ROUTES.ORGANIZATION.name,
                meta: {
                    title: 'Organization',
                    requiresAuth: true,
                    requiresAdmin: true,
                    instructions: '',
                },
                component: () => import('./views/OrganizationView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.MY_DEPARTMENT.path,
                name: PROGRAM_ROUTES.MY_DEPARTMENT.name,
                meta: {
                    title: 'My Department',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'My Department' }
                    ]
                },
                component: () => import('./views/MyDepartmentView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.DEPARTMENT.path,
                name: PROGRAM_ROUTES.DEPARTMENT.name,
                meta: {
                    title: 'Department',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Department' }
                    ]
                },
            },
            {
                path: PROGRAM_ROUTES.ANNUAL_REPORTS.path,
                name: PROGRAM_ROUTES.ANNUAL_REPORTS.name,
                meta: {
                    title: 'Review Annual Reports',
                    instructions: 'Select a report year and report type to view the annual reports.',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Review Annual Reports' }
                    ]
                },
                component: () => import('./views/ProgramAnnualReportsView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.HCES.path,
                name: PROGRAM_ROUTES.HCES.name,
                meta: {
                    title: 'Review HCE Transactions',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Review HCE Transactions' }
                    ]
                },
                component: () => import('./views/ProgramHceView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.EDIT_TRANSACTION.path,
                name: PROGRAM_ROUTES.EDIT_TRANSACTION.name,
                props: true,
                meta: {
                    title: 'Health Care Entity Transaction',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Review HCE Transactions', route: '/program/hces' },
                        { label: 'Health Care Entity Transaction' }
                    ]
                },
                component: () => import('../hcet/views/HceTransactionView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.REPORTING_EXCEPTIONS.path,
                name: PROGRAM_ROUTES.REPORTING_EXCEPTIONS.name,
                meta: {
                    title: 'Reporting Exceptions',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Reporting Exceptions' }
                    ]
                },
                component: () => import('./views/ReportingExceptionsView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.REPORTING_EXCEPTION_RESPONSE.path,
                name: PROGRAM_ROUTES.REPORTING_EXCEPTION_RESPONSE.name,
                meta: {
                    title: 'Reporting Exception Response',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Reporting Exceptions', route: '/program/reportingexceptions' },
                        { label: 'Reporting Exception Response' }
                    ]
                },
                component: () => import('./views/ReportingExceptionResponseView.vue'),
                beforeEnter: filterPath
            },
            {
                path: PROGRAM_ROUTES.REPORTING_EXCEPTION_ADDITIONAL_TIME.path,
                name: PROGRAM_ROUTES.REPORTING_EXCEPTION_ADDITIONAL_TIME.name,
                meta: {
                    title: 'Reporting Exception Additional Time Response',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Reporting Exceptions', route: '/program/reportingexceptions' },
                        { label: 'Reporting Exception Additional Time Response' }
                    ]
                },
                component: () => import('./views/AdditionalTimeResponseView.vue'),
                beforeEnter: filterPath
            },
        ]
    };

export default router => {
    router.addRoute(moduleRoutes);
};